<ng-container>
  @if (entityFile) {
  <img-for-entity
    [image]="entityFile"
    [width]="width"
    [height]="height"
    [alt]="partner.name"
  ></img-for-entity>
  } @else {
  <file-jet-img
    [image]="partner.avatar"
    [width]="width"
    [height]="height"
    [alt]="partner.name"
  ></file-jet-img>
  }
</ng-container>
